import { cwslapi,webapi } from "../index";
import Cookies from "js-cookie";

// 获取验证码图片
export const getCaptchaApi = (data) => {
  return cwslapi({
    url: webapi+"login/getCaptcha",
    method: "get",
    xhrFields: {
      withCredentials: true,
    },
    responseType: "arraybuffer",
  });
};

// 登录
export const getdoLoginApi = (data) => {
  return cwslapi({ 
    url: webapi+"login/doLogin",
    method: "post",
    data,
  });
};


// 获取用户信息 —— 用户管理
export const getMemberInfoApi = (data) => {
  return cwslapi({
    url: "/getMemberInfo",
    method: "post",
    data,
  });
};


// 退出
export const getlogoutApi = (data) => { 
  return cwslapi({
    // url: "http://109.244.44.238:8000/webapi/login/logout?source=web&userId=" + Cookies.get('cwsl_userId'),
    url: webapi+"login/logout?source=web&userId=" + Cookies.get('cwsl_userId'),
    method: "post",
    data,
  });
};